import React, { ReactNode } from 'react'
import {
  BannerOfferSloganBlue,
  UrgencyTextGreen,
} from '../../../../featureVariables'
import { BogoBannerLocation } from '../../../../types/bogoBanner'
import { shouldShowCta } from '../../utils/shouldShowCta'
import { Cta } from '../Cta'
import styles from './BogoBannerContent.module.scss'

export const BogoBannerContent = ({
  location,
  bannerOfferSlogan,
}: {
  location?: BogoBannerLocation
  bannerOfferSlogan?: ReactNode
}) => (
  <>
    <h2
      className={`mc-text-h3 mc-text--brand mc-text--uppercase ${styles.title}`}
    >
      {bannerOfferSlogan || <BannerOfferSloganBlue />}
    </h2>
    <p className='mc-text-h8 mc-opacity--hinted mc-text--uppercase mc-mx-sm-4 mc-my-2 mc-text--center'>
      <UrgencyTextGreen />
    </p>
    {shouldShowCta({ location }) && <Cta />}
  </>
)
